const OPENERS = { '{': '}', '(': ')', '[': ']', '<': '>' };
const CLOSERS = new Set(Object.values(OPENERS));

/**
 * Advances from startIndex, tracking combined bracket depth for {, (, [, <
 * pairs, until it finds a token whose value is in stopValues AT depth 0.
 * @param {{type: string, value: string}[]} tokens
 * @param {number} startIndex
 * @param {string[]} stopValues
 * @returns {number} index of the stop token, or tokens.length if never found
 */
export function findAtDepthZero(tokens, startIndex, stopValues) {
  let depth = 0;
  for (let i = startIndex; i < tokens.length; i += 1) {
    const value = tokens[i].value;
    if (depth === 0 && stopValues.includes(value)) {
      return i;
    }
    if (value === '>' && tokens[i - 1] && tokens[i - 1].value === '=') {
      continue; // second half of '=>' (expression-bodied member/lambda), not a generic closer
    }
    if (OPENERS[value]) {
      depth += 1;
    } else if (CLOSERS.has(value)) {
      depth -= 1;
    }
  }
  return tokens.length;
}

/**
 * Finds the index of the token matching an opening bracket at openIndex.
 * @param {{type: string, value: string}[]} tokens
 * @param {number} openIndex - tokens[openIndex] must be one of { ( [ <
 * @returns {number} index of the matching closer, or tokens.length if unbalanced
 */
export function findMatchingCloser(tokens, openIndex) {
  const opener = tokens[openIndex].value;
  const closer = OPENERS[opener];
  if (!closer) {
    return openIndex;
  }
  let depth = 1;
  for (let i = openIndex + 1; i < tokens.length; i += 1) {
    if (tokens[i].value === opener) depth += 1;
    else if (tokens[i].value === closer) {
      depth -= 1;
      if (depth === 0) return i;
    }
  }
  return tokens.length;
}

/**
 * Looks up the XMLDoc summary (from tokenizeCs's docComments) attached at a
 * given token index — i.e. the index of the first token right after a `///`
 * comment block (the first modifier, or the declaration keyword itself if
 * there are no modifiers).
 * @param {{tokenIndex: number, summary: string}[]} docComments
 * @param {number} tokenIndex
 * @returns {string|null}
 */
export function findDocSummary(docComments, tokenIndex) {
  const entry = docComments.find(function matchIndex(d) { return d.tokenIndex === tokenIndex; });
  return entry ? entry.summary : null;
}
